import { BitkitLink, IconArrowRight } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';

import ActivityList from '@/components/ActivityList/ActivityList';

const NotificationsDrawer = () => {
  return (
    <Box>
      <ActivityList limit={8} />
      <BitkitLink
        key="show-all-notifications"
        colorVariant="purple"
        href="/activity"
        marginLeft="48"
        paddingY="16"
        suffixIcon={IconArrowRight}
        suffixIconSize="16"
      >
        View all
      </BitkitLink>
    </Box>
  );
};

export default NotificationsDrawer;
